export const execIfFunction = <T>(target: ((...args: any[]) => T) | T, ...args: any[]): T =>
  target instanceof Function ? target(...args) : target;
